export default __webpack_public_path__ + "static/media/thumbnail.8db0f368.png";